import { render, staticRenderFns } from "./AnonymousRoot.vue?vue&type=template&id=9b4207c0"
import script from "./AnonymousRoot.vue?vue&type=script&lang=ts"
export * from "./AnonymousRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports